import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { action, observable, computed, toJS } from 'mobx';
import { Link } from 'react-router';
import Dropzone from '../../Dropzone';
import Form, { FormBody, FormActions, TextInput, SelectInput } from '../../Form';
import Tags from '../../Tags';
import { BASE_URL } from '../../../config';
import Spinner from '../../Spinner';
import * as api from '../../../actions/api';
import { station } from "../../../actions/api";
import StationImageView from './StationImageView';

@inject('stationStore', 'metaDataTemplateStore', 'rolePermissionStore', 'locationStore', 'stationTypeStore', 'locationTypeStore')
@observer
class StationMetaData extends Component {
  // static propTypes = {
  // params: PropTypes.shape().isRequired,
  // route: PropTypes.shape().isRequired,
  // };

  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  };

  @observable metaDataAll;
  @observable metaData;
  @observable filteredMetaData;
  // @observable metaDataTemplate;
  @observable tags = [];

  slug = '/station';
  @observable station;
  stationOrig;
  // station;
  // @observable station = {
  // identifier: '',
  // name: '',
  // longitude: undefined,
  // latitude: undefined,
  // elevation: undefined,
  // established: '',
  // description: '',
  // meta_data_template_id: '',
  // tags: [],
  // };

  constructor(props) {
    super(props);

    const { params: { id }, stationStore, metaDataTemplateStore, locationStore, locationTypeStore, stationTypeStore } = props;

    if (!locationStore.items.length && !locationStore.isLoading) locationStore.fetchItems();
    if (!locationTypeStore.items.length && !locationTypeStore.isLoading) locationTypeStore.fetchItems();
    if (!stationTypeStore.items.length && !stationTypeStore.isLoading) stationTypeStore.fetchItems();
    // metaDataTemplateStore.fetchItems();
    // stationStore.fetchItem(id);
    // stationStore.fetchMetaData(id);

    this.metaData = [];
    this.filteredMetaData = [];
    this.handleChange = this.handleChange.bind(this);

    this.onChangeName = this.onChange.bind(this, 'name');
    this.onChangeLongitude = this.onChange.bind(this, 'longitude');
    this.onChangeLatitude = this.onChange.bind(this, 'latitude');
    this.onChangeElevation = this.onChange.bind(this, 'elevation');
    this.onChangeEstablished = this.onChange.bind(this, 'established');
    this.onChangeDescription = this.onChange.bind(this, 'description');
    this.onChangeMetaDataTemplate = this.onChangeMetaDataTemplate.bind(this);
    this.onChangeTags = this.onChangeTags.bind(this);

    this.handleSave = this.handleSave.bind(this);
  }

  componentWillMount() {
    const { params: { id }, stationStore } = this.props;
    // const station = stationStore.findById(id);
    stationStore.fetchItem(id, true).then(() => this.reset(id));
    // this.reset(id);
  }

  componentWillReceiveProps(nextProps) {
    const { params: { id }, stationStore } = nextProps;
    if (id !== this.props.params.id) {
      stationStore.fetchItem(id, true).then(() => this.reset(id));
      // this.reset(id);
    }
  }

  @computed get metaDataTemplate() {
    if (!(this.station && this.station.meta_data_template_id)) {
      return {};
    }
    const { params: { id }, metaDataTemplateStore, stationStore } = this.props;
    const stationObj = stationStore.findById(id);
    const station = stationObj;
    return metaDataTemplateStore.findById(this.station.meta_data_template_id); //return metadata template
  }

  @action reset(id, counter = 0) {
    const { metaDataTemplateStore, stationStore } = this.props;
    const station = stationStore.findById(id);
    // const metaDataTemplate = metaDataTemplateStore.findById(station.meta_data_template_id);
    this.station = Object.assign({}, station.asJson);
    // this.station.meta_data = this.station.meta_data.filter(item => item.meta_data_template_id === station.meta_data_template_id);
    this.stationOrig = station;

    if ((!station || !station.meta_data_template_id || !station.meta_data) && counter < 2) {
      setTimeout(() => {
        this.reset(id, counter + 1);
      }, 100);
    }
  }

  @action resetImages = (id, context) => {
    context.props.stationStore.transportLayer.fetchById(id).then(station => {
      context.station.images = station.images;
      context.props.stationStore.items.filter(station => station.id == id)[0].images = station.images;
    });
  };

  @action
  resetMetaData(items) {
    this.metaDataAll = items;
    this.metaData = [];
  }

  @action
  onChange(field, event) {
    this.station[field] = event.target.value;
  }

  @action
  refreshMetaData(id) {
    console.log('refreshMetaData id', id);
  }

  @action
  refreshMetaData2(id) {
    const { metaDataTemplateStore } = this.props;
    this.station.meta_data_template_id = id;
    const metaDataTemplate = metaDataTemplateStore.findById(id);
    const ids = this.metaDataTemplate &&
      this.metaDataTemplate.meta_data &&
      this.metaDataTemplate.meta_data.map(item => item.id);

    this.metaData = this.metaDataAll && this.metaDataAll.filter(item => {
      return ids.indexOf(item.id) !== -1;
    });
  }

  @action
  onChangeMetaDataTemplate(e) {

    this.station.meta_data_template_id = e.target.value;
    if (+this.station.meta_data_template_id === +this.stationOrig.meta_data_template_id) {
      this.station.meta_data = toJS(this.stationOrig.meta_data);
      return;
    }
    this.station.meta_data = (this.metaDataTemplate.meta_data && this.metaDataTemplate.meta_data) ? this.metaDataTemplate.meta_data.map(item => {
      let originalMetaData = this.stationOrig.meta_data.find(oItem => +oItem.id === +item.id);
      return (Object.assign(item, { value: originalMetaData ? originalMetaData.value : '' }));
    }) : [];

  }

  @action
  onChangeTags(tags) {
    this.station.tags.replace(tags);
  }

  handleChange(id, e) {
    // this.metaData[id] = {
    // ...this.metaData[id],
    // value: e.target.value,
    // };
    this.station.meta_data = this.station.meta_data.map(item => {
      if (item.id === id) {
        return Object.assign({}, item, { value: e.target.value });
      }
      return item;
    });
    // this.stationOrig = toJS(this.station);
  }

  handleSave(e) {
    e.preventDefault();
    const { notify } = this.context;

    const { params: { id }, stationStore } = this.props;

    const station = toJS(this.station);
    const metaData = this.station.meta_data;

    delete station.data_origin;
    delete station.data_series;
    delete station.data_source;
    delete station.monitoring;
    delete station.parameters;
    delete station.images;

    // station.meta_data = toJS(this.station.meta_data);

    station.meta_data = (
      this.station &&
      this.station.meta_data &&
      this.station.meta_data.map(item => {
        // return item.asJson;
        delete item.store;
        return item;
      })
    );

    stationStore.updateItem(station)
      .then(res => {
        // console.log(res);
        stationStore.fetchItem(id, true);
        notify.success();
      })
      .catch(notify.error);
  }

  @action
  deleteImage = (fileId) => {
    let { notify } = this.context;
    let { stationStore } = this.props;

    // console.log(stationStore.items.filter(station => station.id==this.props.params.id)[0]);
    /*global event, fdescribe*/
    /*eslint no-restricted-globals: ["error", "event", "fdescribe"]*/
    if (confirm('Delete file?')) {
      api.station
        .imageRemove(this.props.params.id, fileId)
        .then(res => {
          let station = stationStore.findById(this.props.params.id);
          this.station.images = this.station.images.filter(station => +station.id !== +fileId);
          station.images = station.images.filter(station => +station.id !== +fileId);
          this.reset(this.props.params.id);
          notify.success(res);
        })
        .catch(notify.error);
    }
  };

  render() {
    const { metaDataTemplateStore, stationStore, params: { id }, rolePermissionStore, locationStore, stationTypeStore } = this.props;
    if (stationStore.isLoading || metaDataTemplateStore.isLoading) {
      return <Spinner />;
    }
    if (!this.station) {
      return <Spinner />;
    }

    // console.log(toJS(this.station))

    const tagsList = this.station.tags.map(item => item.name).join(', ');
    const station = stationStore.findById(id);
    const metaDataTemplate = metaDataTemplateStore.findById(this.station.meta_data_template_id || station.meta_data_template_id);
    const templateMetaData = metaDataTemplate && metaDataTemplate.meta_data && metaDataTemplate.meta_data.length ? metaDataTemplate.meta_data.sort((a, b) => +a.seq < +b.seq ? -1 : 1) : [];

    const notNull = value => !(!value && value !== '');

    if (rolePermissionStore.validateRole('modify meta-data')) {
      return (
        <div>
          <div className='inline-grid space-between'>
            <div>
              <Form>
                <FormBody>
                  <TextInput label={'Id'} value={id} readOnly />
                  <TextInput label={'Identifier'} value={this.station.identifier} readOnly />
                  <TextInput label={'Name'} value={this.station.name} onChange={this.onChangeName} />
                  <TextInput label={'Longitude'} value={this.station.longitude} onChange={this.onChangeLongitude} />
                  <TextInput label={'Latitude'} value={this.station.latitude} onChange={this.onChangeLatitude} />
                  <TextInput label={'Elevation'} value={this.station.elevation} onChange={this.onChangeElevation} />
                  {/* <TextInput label={'Established'} value={this.station.established} onChange={this.onChangeEstablished} /> */}
                  <TextInput label={'Description'} value={this.station.description} onChange={this.onChangeDescription} />
                  <SelectInput label={'Type'} fields={{ label: 'full_type', value: 'id' }}
                    options={stationTypeStore.getTypeHierarchy()}
                    onChange={e => this.station.station_type_id = e.target.value}
                    value={this.station.station_type_id}
                  // onCreateItem={() => this.context.router.push(`/station/${id}/meta-data/station-type/add`)}
                  />
                  <SelectInput
                    label={'Location'}
                    fields={{ label: 'full_location', value: 'id' }}
                    options={locationStore.getLocationHierarchy()}
                    onChange={e => this.station.location_id = e.target.value}
                    value={this.station.location_id}
                    onCreateItem={() => this.context.router.push(`/station/${id}/meta-data/location/add`)}
                  />
                </FormBody>

                <br />
                <SelectInput
                  label={'Meta Data Template'}
                  fields={{ label: 'name', value: 'id' }}
                  options={metaDataTemplateStore.items.toJS()}
                  onChange={this.onChangeMetaDataTemplate}
                  value={notNull(this.station.meta_data_template_id) ? this.station.meta_data_template_id : ''}
                />

                <br />

                {/* <Link to="/meta-data-template" className="button small">Create / Edit Template</Link> */}
                <button onClick={() => this.context.router.push('/configurations/meta-data/template')}>Create/Edit Template</button>
                <br />
                <br />
                <br />

                <FormBody>
                  {templateMetaData.sort((a, b) => a.seq < b.seq ? -1 : 1).map((item, i) => {
                    let metaData = this.station.meta_data.find(md => +md.id === +item.id);
                    // console.log(metaData, `station-${id}-meta-data-${item.id}-${item.name}-${i}`)
                    return (
                      <TextInput
                        key={`station-${id}-meta-data-${item.id}-${item.name}-${i}`} label={item.name}
                        value={metaData ? metaData.value : ''}
                        onChange={this.handleChange.bind(this, item.id)}
                      />
                    )
                  })
                  }
                </FormBody>
                <FormActions>
                  <button onClick={this.handleSave}>Save</button>
                </FormActions>
              </Form>
            </div>

            <div style={{ width: '500px' }}>
              <Tags tags={this.station.tags} onChange={this.onChangeTags} />
              <br />
              <StationImageView images={station.images} deleteImage={this.deleteImage} />
              {/* {station.images.map((image, i) => (
                <div key={i} className="imageContainer" style={{ width: i === 0 ? '100%' : '25%' }}>
                  <div className="imageRemove"><span id={image.id} className="fa fa-remove" onClick={this.deleteImage} />
                  </div>
                  <img id={image.name} key={image.name} src={`${BASE_URL}/images/${image.name}`} style={{ width: '100%' }} alt='not-found' />
                </div>
              ))} */}

              <br />
              <br />
              <Dropzone id={id} resetImages={this.resetImages} context={this}
                destination={`/api/station/${id}/image/upload`} />
            </div>
            <div className="cf" />
          </div>
          <Link to={`/station/${id}/meta-data-audit`}><div style={{ float: 'right', fontStyle: 'italic', color: '#006effab', textDecoration: 'underline', fontSize: '14px' }}>View audit history</div></Link>
          {!!this.props.children && React.cloneElement(this.props.children, { slug: `/station/${id}/meta-data` })}
        </div>
      );
    } else {
      return (
        <div className='inline-grid space-between'>
          <div>
            <Form>
              <FormBody>
                <TextInput label={'Id'} value={id} readOnly />
                <TextInput label={'Identifier'} value={this.station.identifier} readOnly />
                <TextInput label={'Name'} value={this.station.name} onChange={this.onChangeName} readOnly />
                <TextInput label={'Longitude'} value={this.station.longitude} onChange={this.onChangeLongitude} readOnly />
                <TextInput label={'Latitude'} value={this.station.latitude} onChange={this.onChangeLatitude} readOnly />
                <TextInput label={'Elevation'} value={this.station.elevation || ''} onChange={this.onChangeElevation} readOnly />
                {/*
                 <TextInput label={'Established'} value={this.station.established}
                 onChange={this.onChangeEstablished}
                 />
                 */}
                <TextInput label={'Description'} value={this.station.description} onChange={this.onChangeDescription} readOnly />
                <br />

                {metaDataTemplateStore.items.length && station && station.meta_data && station.meta_data_template_id && <TextInput label='Meta Data Template' value={metaDataTemplateStore.items.find(item => item.id === station.meta_data_template_id).name} readOnly />}
                {templateMetaData.map((item, i) => {
                  let metaData = this.station.meta_data.find(md => +md.id === +item.id);
                  return (
                    <TextInput
                      key={`station-${id}-meta-data-${item.id}-${item.name}-${i}`} label={item.name}
                      value={metaData ? metaData.value : ''}
                      onChange={this.handleChange.bind(this, item.id)}
                    />
                  )
                })
                }
                {/*{station && station.meta_data && this.station.meta_data && (*/}
                {/*this.station.meta_data.map(item => (*/}
                {/*<TextInput*/}
                {/*key={item.id} label={item.name}*/}
                {/*value={item.value || ''}*/}
                {/*onChange={this.handleChange.bind(this, item.id)}*/}
                {/*readOnly*/}
                {/*/>*/}
                {/*))*/}
                {/*)}*/}
              </FormBody>

              <br />
            </Form>
          </div>

          <div style={{ maxWidth: '500px' }}>
            <Tags tags={this.station.tags} onChange={() => { }} />
            <br />
            <StationImageView images={station.images} />
            {/* {station.images.map((image, i) => (
              <div key={i} className="imageContainer" style={{ width: i === 0 ? '100%' : '25%' }}>
                <img id={image.name} key={image.name} src={`${BASE_URL}/images/${image.name}`} style={{ width: '100%' }} alt='not-found' />
              </div>
            ))} */}

            <br />
            <br />
          </div>
          <div className="cf" />
        </div>
      );
    }
  }
}

export default StationMetaData;



// WEBPACK FOOTER //
// ./src/components/Station/MetaData/StationMetaData.js